module.exports = "/assets/hero-bfw_02.jpg?5nSGzg+";